import styles from "./HeaderTitleContent.module.scss";
import ReturnBackBtn from "../ReturnBackBtn/ReturnBackBtn";

export interface HeaderTitleContentProps {
  children?: React.ReactNode;
  onGoBack?: () => void;
  goBackBtnName?: string;
  withGoBackBtn?: boolean;
  goBackBtnLabel?: string;
  goBackTo?: string;
  SubTitleRender?: React.ReactNode;
  spaceBetween?: boolean;
  rightContainer?: React.ReactNode;
}
export default function HeaderTitleContent({
  children,
  withGoBackBtn,
  goBackBtnLabel,
  goBackTo,
  onGoBack,
  SubTitleRender,
  spaceBetween,
  rightContainer
}: HeaderTitleContentProps) {
  return (
    <div

      className={styles["header"]}
      style={{display: "flex", justifyContent: "space-between"}}
    >
      <div>
      <div className={styles["header__back-btn"]}>
        {withGoBackBtn && (
          <ReturnBackBtn
            label={goBackBtnLabel}
            linnkTo={goBackTo}
            onClick={onGoBack}
            size="small"
          />
        )}
      </div>

      <h1 className={styles["header__title"]}>
        {children}
        {SubTitleRender && (
          <span style={{ fontSize: "1rem", marginLeft: 10, color: "gray" }}>
            {SubTitleRender}
          </span>
        )}
      </h1>
      </div>
      {
        rightContainer && <div>{rightContainer}</div>
      }

    </div>
  );
}
